import { CONFIG } from '../../core/config';
import { BusinessEntity } from '../business-entity';
import { InspectionPlanStatus } from './inspection-plan-status.enum';
import { ModelRunMitigationColumn } from './model-run-mitigation-column';
import { Recommendation } from './recommendation';

export class Recommendations extends BusinessEntity {
  public orgTreeNodeModelRunId: string;
  public runnableModelOrgTreeNodeId: string;
  public inspectionPlanId: string;
  public inspectionPlanStatus: InspectionPlanStatus;
  public modelName: string;
  public analysisName: string;
  public items: Recommendation[] = [];
  public mitigationColumns: ModelRunMitigationColumn[] = [];

  public hasActivePlan: boolean;
  public isErpEnabled: boolean;

  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Recommendation';
    this.apiRoute = CONFIG.apiRoutes.recommendations;
  }

  public json(): this {
    return this;
  }

  public loadFromJson(data: Partial<Recommendations>) {
    super.loadFromJson(data);
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;

    this.modelName = data.modelName;
    this.analysisName = data.analysisName;
    this.inspectionPlanId = data.inspectionPlanId;
    this.inspectionPlanStatus = data.inspectionPlanStatus;

    this.runnableModelOrgTreeNodeId = data.runnableModelOrgTreeNodeId;

    this.hasActivePlan = data.hasActivePlan;
    this.isErpEnabled = data.isErpEnabled;
    this.items = new Array<Recommendation>();
    this.canEdit =this.inspectionPlanStatus === InspectionPlanStatus.Draft;

    if (data.items) {
      for (const rawInput of data.items) {
        const item = new Recommendation();

        item.loadFromJson(rawInput);
        this.items.push(item);
      }
    }

    if (data.mitigationColumns) {
      for (const rawMitigationColumn of data.mitigationColumns) {
        const mitigationColumn = new ModelRunMitigationColumn();

        mitigationColumn.loadFromJson(rawMitigationColumn);
        this.mitigationColumns.push(mitigationColumn);
      }
    }
  }

  get hasActive(): boolean {
    return this.hasActivePlan;
  }
}
